import { useIntl } from 'react-intl';
import { Alert } from '@rossum/ui/material';

/**
 * Shown instead of the editable assistant controls when the queue is set up with
 * the automation assistant but the organization has not purchased it.
 */
export const ReadOnlyAssistantAlert = () => {
  const intl = useIntl();

  return (
    <Alert severity="warning">
      {intl.formatMessage({
        id: 'containers.settings.queues.queue.automation.optimization.readOnlyAssistantAlert.title',
      })}
    </Alert>
  );
};
